/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Shared state data
 * -----------------------------------------------------------------------------
 *
 * @namespace store
 */

var store = {
  // Elements via data attributes
  selectors: {
    sitePreloader: '[data-site-preloader]',
    productObj: '[data-product-json]',
    siteOverlay: '[data-site-overlay]',
    siteHeader: '[data-site-header]',
    headerSlider: '[data-header-slider]',
    searchLayer: '[data-search-layer]',
    newsletterPopup: '[data-newsletter-popup]',
    carousel: '[data-flickity]',
    productToolbarMobile: '[data-product-toolbar-mobile]',
    productTabs: '[data-product-tabs]',
    accountTabs: '[data-account-tabs]',
    singleOptionSelector: '[data-single-option-selector]',
    qtyContainer: '[data-qty-container]',
    qtyInput: '[data-qty-input]',
    cartItem: '[data-cart-item]',
    productForm: '[data-product-form]',
    cartForm: '[data-cart-form]',
    loginForm: '[data-login-form]',
    recoverForm: '[data-recover-form]',
    passwordInput: '[data-password-input]',
    imageZoom: '[data-img-zoom]'
  },

  // Global objects
  currentTemplate: null,
  isLoading: false,
  moneyFormat: window.theme.moneyFormat,
  colorSwatchesEnabled: window.theme.colorSwatchesEnabled,
  sizeSwatchesEnabled: window.theme.sizeSwatchesEnabled,
  productExcludeTag: window.theme.productExcludeTag,
  // eslint-disable-next-line no-eval
  freeShippingAmount: eval(window.theme.freeShippingEligible),
  enablefreeShipMsg: true,

  // Wishlist Objects
  selectedForwishlist: {},
  wishlist: [],
  recentlyViewed: [],
  iswishlist: false,
  iswishlistPopup: false,
  iswishlistlist: false,
  isSuccessFully: false,
  iswishlistTrue: false,
  isEditWishlist: false,
  isShareWishlist: false,
  isListFormOpen: true,
  proCustomer: window.theme.proCustomer,
  proDiscountPer: window.theme.proDiscountPer,
  customerLoggedIn: window.theme.customerLoggedIn,
  customer: {
    name: window.theme.customerName,
    email: window.theme.customerEmail
  },
  wishlistGroup: {
    getWishlistData: {},
    currentList: {},
    products: [],
    list: [],
    shareList: [],
    shareListTitle: '',
    cartList: [],
    messages: {
      product: {
        title: window.theme.productAddSuccessTitle,
        description: window.theme.productAddSuccessDesc
      },
      listRemove: [],
      listCreate: [],
      listEdit: {
        title: window.theme.listEditSuccessTitle,
        description: window.theme.listEditSuccessDesc
      }
    }
  },
  wishListedProducts: [],
  wishListedProductsHandles: [],

  // all script
  allScript: {},
  // HawkSearchLoading: true,
  // ReCharge Integration
  reChargeDiscountVariantId: null
};

export default store;